import { dyApi } from '@castlery/shared-redux-services';
import type { CampaignsRequestOptions } from '../entity';
import { getDyApiPayload, getDyApiHeader, getDyCookies } from '../utils';

export const dyRecommendationsApi = dyApi.injectEndpoints({
  endpoints: (builder) => {
    return {
      getDyCampaigns: builder.query<any, CampaignsRequestOptions>({
        query: (payload) => ({
          url: `serve/user/choose`,
          method: 'POST',
          headers: getDyApiHeader(),
          body: getDyApiPayload(payload, getDyCookies()),
        }),
      }),
    };
  },
});

export const { useGetDyCampaignsQuery, useLazyGetDyCampaignsQuery } = dyRecommendationsApi;
export const { getDyCampaigns } = dyRecommendationsApi.endpoints;
